import { folderSchemas } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";

export const saveReplenishmentRequestViewsAndFolders = {
  name: "saveReplenishmentRequestViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["replenishment-requests"]),
    views: z.array(viewWithIdSchemas["replenishment-requests"]),
  }),
  output: zNull(),
};
